import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./MainSection.css";

import logo from '../images/6_Ayur copy.webp'
import { MdCall } from "react-icons/md";
import { Link, NavLink,useLocation } from "react-router-dom";
import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";


export default function MainSection() {
  useEffect(() => {
  Aos.init({
    duration: 1000,      // animation duration
    easing: "ease-in-out",
    once: true,          // animation happens only once
    offset: 100,         // offset from the trigger point
  });

  Aos.refresh(); // optional but recommended
}, []);

 const location = useLocation();

  const isTreatmentActive =
    location.pathname.startsWith("/treatment") ||
    location.pathname.startsWith("/postnatal") ||
    location.pathname.startsWith("/rejuvenation") ||
    location.pathname.startsWith("/hair_treatment") ||
    location.pathname.startsWith("/lifestyle_yoga") ||
    location.pathname.startsWith("/soundarya_kalpa");

  return (
    <section className="sec container-fluid">

      {/* Overlay */}
      <div className="sec-overlay"></div>

      {/* ===== HEADER / NAVBAR ===== */}
   <nav className="navbar navbar-expand-lg navbar-dark sec-header para-font">
  <div className="container-fluid px-5">

    {/* Logo */}
    <div className="d-flex align-items-center ">
      <Link className="navbar-brand" to="#"><span><img src={logo} alt="logo" className="brand-logo bg_new"/><span  className=" logo_txt mt-5" ></span></span>
        
      </Link>
     
    </div>

    {/* Toggle */}
    <button
      className="navbar-toggler "
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#secNavbar"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    {/* Menu Links */}
    <div className="collapse navbar-collapse justify-content-center" id="secNavbar">
      <ul className="navbar-nav gap-lg-4 text-center">
        <li className="nav-item"><NavLink className="nav-link" to="/" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Home</b></NavLink></li>
        <li className="nav-item"><NavLink className="nav-link" to="/ourstory" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Our Story</b></NavLink></li>
        {/* <li className="nav-item"><a className="nav-link" href="#">Treatments</a></li> */}
        <li className="nav-item dropdown">
  <NavLink
    to="/treatment"
    className="nav-link dropdown-toggle"
    data-bs-toggle="dropdown"
    style={() => ({
      color: isTreatmentActive ? "orange" : "white"
    })}
  >
    <b>Treatments</b>
  </NavLink>

  <ul className="dropdown-menu">
    <li>
      <NavLink
        to="/treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        All Treatments
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/postnatal"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Postnatal Care
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/rejuvenation"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Rejuvenation Therapy
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/hair_treatment"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Hair Treatment
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/lifestyle_yoga"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Life Style Guidance & Yoga
      </NavLink>
    </li>

    <li>
      <NavLink
        to="/soundarya_kalpa"
        className="dropdown-item"
        style={({ isActive }) => ({
          color: isActive ? "green" : "black"
        })}
      >
        Soundarya Kalpa
      </NavLink>
    </li>
  </ul>
</li>

        <li className="nav-item"><NavLink className="nav-link" to="/contact" style={({ isActive }) => ({ color: isActive ? "green" : "white" })}><b>Contact</b></NavLink></li>
      </ul>
    </div>

    {/* Contact CTA */}
    <div className="d-none d-lg-flex align-items-center gap-3">
     <span className="phone-inline">
       <MdCall /> <b>+91 7736 111 482</b>
     </span>
    <a
  href="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20book%20a%20consultation"
  target="_blank"
  rel="noopener noreferrer"
  className="messenger-btn "
  style={{ backgroundColor: "#006400", textDecoration: "none" }}
>
  WhatsApp
</a>

    </div>

  </div>
</nav>


      {/* ===== CONTENT ===== */}
      <div className="sec-content">
        {/* LEFT */}
        <div className="sec-left" data-aos="fade-up"
     data-aos-duration="3000">
        <h1 className="rubik-mono-one-regular" style={{color:'wheat'}}>Heal Traditionally</h1>
          <p style={{color:'white',fontSize:'20px',fontStyle:'italic'}}>
          We Are Here To Help You Heal Traditionally Within A Tranquil Setting Shaped By Nature And <br/>Timeless Ayurvedic Tradition.
          </p>
          <div className="free-badge mt-5">
            <span className="badge-text">
              <Link to="https://wa.me/917736111482?text=Hello%20I%20would%20like%20to%20book%20a%20consultation"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="messenger-btn"
                    style={{ backgroundColor: "#006400", textDecoration: "none", }} >
                  Book a Consultation
                  </Link>
            </span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="">
         
            <img
    src={require("../images/dss.webp")}  
    alt="Ayurvedic Leaf"
    className="sec-leaf img-fluid"
  />
        </div>

      </div>

      {/* ===== WAVE ===== */}

{/* ===== WAVE SHAPE MATCHING 2nd IMAGE ===== */}
<div >
<svg className="sec-wave" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
            <path fill="#f7f0d3" fillOpacity="1"
              d="M0,224L60,218.7C120,213,240,203,360,181.3C480,160,600,128,720,112C840,96,960,96,1080,117.3C1200,139,1320,181,1380,202.7L1440,224L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z">
            </path>
          </svg>

</div>



    </section>
  );
}
